// src/analysis/planificacionHerbicidasProcess/planificacionHerbicidasProcess.jsx
//
// Proceso análogo al de planificacionCosechaProcess, pero
// enviando el archivo al endpoint de herbicidas y mostrando
// mensajes correspondientes.

import axios from 'axios';
import pako from 'pako';
import { toast } from 'react-toastify';
import { API_BASE_PYTHON_SERVICE } from '../../utils/config';


export const ejecutarPlanificacionHerbicidas = async ({
                                                          selectedFile,
                                                          idMax,
                                                          idUsuario,
                                                          setProcessingFinished,
                                                          socket,
                                                          socketSessionID,
                                                          setShowProgressBar,
                                                          setProgress,
                                                          setPolygonsHerbicidesPlanning
                                                      }) => {
    setProgress(0);
    setShowProgressBar(true);

    try {
        // 1️⃣ Comprimir el archivo (igual que en cosecha)
        const fileBuffer      = await selectedFile.arrayBuffer();
        const compressedData  = pako.gzip(new Uint8Array(fileBuffer), { level: 9 });
        const compressedFile  = new Blob([compressedData], { type: 'application/gzip' });

        // 2️⃣ Preparar payload
        const formData = new FormData();
        formData.append('file',        compressedFile, `${selectedFile.name}.gz`);
        formData.append('session_id',  socketSessionID);
        formData.append('idMax',       idMax);
        formData.append('idUsuario',   idUsuario);

        // 3️⃣ POST al backend (cambia únicamente el endpoint)
        const { data } = await axios.post(
            `${API_BASE_PYTHON_SERVICE}mapping/planificacion_herbicidas`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (data.status === 'error') throw new Error(data.message);

        // 4️⃣ Descargar el GeoJSON generado y guardarlo en estado
        const geojsonResponse = await axios.get(data.url_geojson);
        setPolygonsHerbicidesPlanning(geojsonResponse.data);

        setProgress(100);
        setProcessingFinished(true);
        setShowProgressBar(false);
        toast.success('✓ Planificación de Herbicidas procesada correctamente.', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
        });
    } catch (err) {
        console.error('[Planificación Herbicidas] Error:', err);
        toast.error(err.message || 'Ocurrió un error, consulta con tu administrador.', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
        });
        setShowProgressBar(false);
        setProcessingFinished(true);
    }
};

export const shouldEnableExecBashPlanificacionHerbicidas = (selectedZipFile) =>
    selectedZipFile !== null;
